<template>
  <div id="app">

    <div class="hello">
      <nav>
      <div class="row" style="justify-content: space-between;margin-bottom: 10px;">
        <img :src="logo" style="width:60px;height:60px;border-radius: 10px;" />
        <div class="row">
          <router-link class="link column" to="/">
            <div @click="choose(0)">网站首页</div>
            <div :class="index==0?'yes':'no'" style="width:10px;margin-top: 5px;"></div>
          </router-link>
          <router-link class="link column" to="/products">
            <div @click="choose(1)">产品中心</div>
            <div :class="index==1?'yes':'no'" style="width:10px;margin-top: 5px;"></div>
          </router-link>
          <router-link class="link column" to="/about">
            <div @click="choose(2)">关于我们</div>
            <div :class="index==2?'yes':'no'" style="width:10px;margin-top: 5px;"></div>
          </router-link>
          <router-link class="link column" to="/contact">
            <div @click="choose(3)">联系我们</div>
            <div :class="index==3?'yes':'no'" style="width:10px;margin-top: 5px;"></div>
          </router-link>
        </div>
      </div>
      </nav>
    </div>

    <router-view/>

    <footer class="column" style="color:#fff;width:100%;position:absolute;left:0;bottom:0;">
      <div class="row" style="background: rgb(22,105,242);padding:40px 0;width:100%;">
        <div class="row" style="width:calc(50vw);justify-content: space-between;">
          <div class="bottomtext">
            <div class="title">关于我们</div>
            <div>
              <p class="info">公司简介</p>
              <p class="info">发展历程</p>
              <p class="info">企业荣誉</p>
            </div>
          </div>
          <div class="bottomtext">
            <div class="title">新闻动态</div>
            <div>
              <p class="info">公司动态</p>
              <p class="info">专题活动</p>
              <p class="info">行业资讯</p>
            </div>
          </div>
          <div class="bottomtext">
            <div class="title">产品中心</div>
            <div>
              <p class="info">客户端</p>
              <p class="info">师傅端</p>
              <p class="info">后台系统</p>
            </div>
          </div>
          <div class="bottomtext">
            <div class="title">公司业务</div>
            <div>
              <p class="info">社区服务</p>
              <p class="info">燃气服务</p>
              <p class="info">维修服务</p>
            </div>
          </div>
          <div class="bottomtext">
            <div class="title">联系我们</div>
            <div>
              <p class="info">常见问题</p>
              <p class="info">加入我们</p>
              <p class="info">合作咨询</p>
            </div>
          </div>
        </div>
        <!-- <div>微信客服</div> -->
      </div>
      <div style="background:rgb(0,73,148);padding:10px 0;width:100%;font-size: 12px;">Copyright @2015-2023 All rights reserved <a target="_blank" href="https://beian.miit.gov.cn/" style="text-decoration: none;color:#fff;margin-left: 10px;">鄂ICP备2023028502号-1</a></div>
    </footer>

  </div>

</template>

<script>
  import logo from './assets/logo.png'

  export default {
    name: 'HomeView',
    data(){
      return {
        date:'123',
        index:0,
        logo:logo
      }
    },
    methods:{
      choose(index){
        this.index=index
        sessionStorage.setItem('index',index)
      }
    },
    mounted(){
      this.index=sessionStorage.getItem('index')
      //console.log()
    },
  }
</script>

<style>
body{
  background: #f5f5f5;
  margin:10px 0 0 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position:relative;
  min-height: calc(100vh);
}
.home{
  padding-bottom: 230px;
}
.yes{
  border-bottom: 3px solid #1E88F5;
}
.no{
  border-bottom: 3px solid #f5f5f5;
}

.row{
  display:flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.column{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

nav {
  padding:0 calc(25vw);
}

.link{
  margin:0 40px;
}

nav a {
  color: #2c3e50;
  text-decoration: none;
}

nav a.router-link-exact-active {
  color: #1E88F5;
}

.title{
  font-weight: bold;
}
.info{
  font-size: 12px;
}
.bottomtext{
  margin:0 0px;
}
</style>
